import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { selectAccessToken, selectAccountMembershipId } from '@shared/api/reduxToolkit';
import { useGetCurrentUserQuery } from '@shared/api/rtkQuery';
import { i18TranslationNS, Translation } from '@shared/config/i18n';
import { useCompanyInitializer } from "@shared/lib/hooks";
import { showCustomToast, TOAST_TYPES } from '@shared/ui/toast';

export const AppInitializers = ({ children }) => {
  const accessToken = useSelector(selectAccessToken);
  const accountMembershipId = useSelector(selectAccountMembershipId);

  useGetCurrentUserQuery(undefined, {
    skip: !accessToken || !!accountMembershipId,
  });

  useCompanyInitializer();

  // refetchOnReconnect (see baseApi.js) already makes every active query silently refetch once
  // the browser regains connectivity — this only surfaces that transition to the user, since a
  // page that goes blank/erroring and then quietly heals itself is confusing without a signal.
  // No custom `id` is passed to showCustomToast: its default id is derived from type+messageKey,
  // so the offline and online toasts get distinct ids and can't accidentally dedupe each other.
  useEffect(() => {
    const handleOnline = () =>
      showCustomToast(TOAST_TYPES.ONLINE, { key: Translation.NETWORK_STATUS_ONLINE, ns: i18TranslationNS });
    const handleOffline = () =>
      showCustomToast(TOAST_TYPES.OFFLINE, { key: Translation.NETWORK_STATUS_OFFLINE, ns: i18TranslationNS });

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return children;
};
